import { useEffect, useState } from 'react';
import { plateformeApi } from '../../api/resources';
import { Bar } from '../../components/ui/Bar.jsx';
import { Btn } from '../../components/ui/Btn.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { C } from '../../theme/palette';

/**
 * Les inscriptions à SwissTech, pour son créateur seul : le serveur le
 * reconnaît à son adresse de connexion. Rangé dans Mon compte plutôt qu'en
 * grand bouton sur la page Plus, où il prenait la place des modules.
 *
 * @param {object} props propriétés du composant
 * @param {(route: string) => void} props.onNav navigation
 * @returns {import('react').ReactElement|null} la carte, ou rien pour les autres comptes
 */
export function AccesCreateurCard({ onNav }) {
  const [createur, setCreateur] = useState(false);
  useEffect(() => {
    let vivant = true;
    Promise.resolve()
      .then(() => plateformeApi.acces())
      .then((r) => {
        if (vivant) setCreateur(!!r?.createur);
      })
      .catch(() => {});
    return () => {
      vivant = false;
    };
  }, []);
  if (!createur) return null;
  return (
    <div data-testid="acces-createur">
      <Card>
        <Bar
          icon="🛠"
          title="Créateur de SwissTech"
          color={C.navy}
          sub="Visible seulement par toi"
        />
        <div style={{ padding: 13 }}>
          <Btn
            label="📋 Inscriptions à SwissTech"
            color={C.navy}
            sm
            full
            onClick={() => onNav && onNav('inscriptions')}
          />
        </div>
      </Card>
    </div>
  );
}
